import { extendTheme } from '@chakra-ui/react';

const customPalette = {
  asphalt: {
    '1': '#7D838A',
    '2': '#B2B8BF',
    '3': '#D0D7DD',
    '4': '#E4E8EB',
    '5': '#F5F5F5',
    '6': '#E8E8E8',
    '7': '#F2F2F2',
    '8': '#212121',
  },
  azure: {
    '1': '#1358BF',
  },
  disabledText: '#9E9E9E',
  graphite: {
    '1': '#1F1F22',
    '2': '#565B62',
  },
  malachite: {
    '1': '#005E7F',
    '2': '#107F8C',
    '3': '#21A19A',
    '4': '#90D0CC',
    '5': '#E5FCF7',
  },
  green: {
    '1': '#148F2B',
    '2': '#E7F6EA',
    '3': '#08A652',
    '4': '#E0ECE2',
  },
  orange: {
    '0': '#FFF5F0',
    '6': '#D14D00',
  },
  snowy: '#FFFFFF',
};

export const theme = extendTheme({
  colors: {
    transparent: 'transparent',
    black: customPalette.graphite[1],
    white: customPalette.snowy,
    paper: customPalette.asphalt[5],
    grayText: customPalette.asphalt[1],
    hover: customPalette.asphalt[4],
    grayBorder: customPalette.asphalt[3],
    highlight: customPalette.green[1],
    selectedMaster: customPalette.green[2],
    masterSelectControls: customPalette.green[3],
    promoControls: customPalette.green[3],
    promoBg: customPalette.green[4],
    warning: customPalette.orange[6],
    warningBg: customPalette.orange[0],

    ...customPalette,
  },
  breakpoints: {
    /**
     * useBreakpointValue() is infinitely refreshing on mobile if pixels are here.
     * See https://github.com/chakra-ui/chakra-ui/issues/3042. maybe an update would help.
     */
    xs: '22.8125em',
    lg: '60em',
  },
  config: {
    initialColorMode: 'light',
  },
  fonts: {
    body: 'SBSansInterface',
  },
  textStyles: {
    h2: {
      fontSize: '1.31rem',
      lineHeight: '2rem',
      fontWeight: 'semibold',
    },
    h3: {
      fontSize: '1.125rem',
      lineHeight: '1.5rem',
    },
    h4: {
      fontSize: '1rem',
      lineHeight: '1.5rem',
      fontWeight: 'semibold',
    },
    body1: {
      fontSize: '0.875rem',
      lineHeight: '1.43rem',
    },
    body2: {
      fontSize: '0.875rem',
      lineHeight: '1rem',
    },
    warning: {
      fontSize: '1rem',
      lineHeight: '1.25rem',
      fontWeight: 500,
    },
    stepper: {
      fontSize: '0.8125rem',
      lineHeight: '1.125rem',
      fontWeight: 500,
    },
    vkH1: {
      fontSize: '2rem',
      lineHeight: '2rem',
    },
    vkBody: {
      fontSize: '1.25rem',
      lineHeight: '1.5rem',
    },
  },
});

export type CustomTheme = typeof theme;
